import { FC, useEffect } from "react";
import { Label, Row } from "reactstrap";
import { BlkField } from "../../../coms/BlkField";
import { BlkCalendario } from "../../../coms/BlkCalendario";
import { Form, useFormikContext } from "formik";
import { FileDownloadButton } from "../../../components/FileDownloadButton";
import { routes } from "../../General";

interface ReportRequest {
    from: Date;
    to: Date;
    cutOffDate: Date;
}

interface ReportFormProps {
    title: string;
    description: string;
    requestPath: string;
    initialFromValue?: Date;
    initialToValue?: Date;
    initialCutOffDateValue?: Date;
}

const FROM = "from";
const TO = "to";
const CUT_OFF_DATE = "cutOffDate";

export const ReportForm: FC<ReportFormProps> = ({
    title,
    description,
    requestPath,
    initialFromValue,
    initialToValue,
    initialCutOffDateValue,
}) => {
    const { values, isValid, setFieldTouched, setFieldValue } = useFormikContext<ReportRequest>();

    useEffect(() => {
        const setInitialData = async () => {
            if (initialFromValue) await setFieldValue(FROM, initialFromValue);
            if (initialToValue) await setFieldValue(TO, initialToValue);
            if (initialCutOffDateValue) await setFieldValue(CUT_OFF_DATE, initialCutOffDateValue);
        };
        setInitialData().then(async () => {
            await setFieldTouched(FROM, true, true);
            await setFieldTouched(TO, true, true);
            await setFieldTouched(CUT_OFF_DATE, true, true);
        });
    }, []);

    return (
        <Form>
            <Row>
                <span className="text-primary-900 font-weight-medium h2">{title}</span>
            </Row>
            <Row>
                <div className={"form-group col-md-3 col-sm-6"}>
                    <Label>{description}</Label>
                </div>
            </Row>
            <Row>
                <div className={"form-group col-md-3 col-sm-6"}>
                    <Label>Desde*:</Label>
                    <BlkField name={FROM} placeholder={"Desde"} component={BlkCalendario} />
                </div>
                <div className={"form-group col-md-3 col-sm-6"}>
                    <Label>Hasta*:</Label>
                    <BlkField name={TO} placeholder={"Hasta"} component={BlkCalendario} />
                </div>
            </Row>
            <Row>
                <div className={"form-group col-md-3 col-sm-6"}>
                    <Label>Fecha de corte*:</Label>
                    <BlkField name={CUT_OFF_DATE} placeholder={"Fecha de corte"} component={BlkCalendario} />
                </div>
            </Row>
            <br />
            <Row>
                <div className="form-group col-md-6 col-sm-12">
                    <FileDownloadButton
                        url={`${routes.api}${requestPath}`}
                        payloadSearch={{ ...values }}
                        isDisabled={!isValid}
                    />
                </div>
            </Row>
        </Form>
    );
};
